import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../State';
import { ConstructionDiaryActionTypes } from '../State/actions/construction-diary.actions';
import { BaseEntityReloadResolver2 } from './resolver.helper';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { distinctUntilChanged, of, switchMap } from 'rxjs';
import {
    getConstructionDiaryFetchedByCommissionId,
    getConstructionDiaryLatestUpdatedAtForCommissionId,
} from '../State/selectors/construction-diary.selectors';
import { filter, map, take, tap } from 'rxjs/operators';
import moment from 'moment';


export const ConstructionDiaryByCommissionIdResolver: ResolveFn<boolean> = (route: ActivatedRouteSnapshot) => {
    const store = inject(Store<State>);
    const commissionIdParam = route.paramMap.get('commissionId');
    if (!commissionIdParam) return of(false);
    const commissionId = +commissionIdParam;

    return ConstructionDiaryByCommissionIdResolverWithoutRoute(store, commissionId)
};

export const ConstructionDiaryByCommissionIdResolverWithoutRoute: (store: Store<State>, commissionId: number) => (Observable<boolean>) = (store: Store<State>, commissionId: number) => {
    if (!commissionId) return of(false);
    const fetched$ = store.select(
        getConstructionDiaryFetchedByCommissionId(commissionId)
    );

    return fetched$.pipe(
        take(1),
        switchMap(fetched => {

            if (!fetched) {
                store.dispatch(
                    ConstructionDiaryActionTypes.Load({
                        Payload: {
                            commissionId,
                            updatedSince: undefined,
                        },
                    }),
                );

                return fetched$.pipe(
                    filter(Boolean),
                    take(1)
                );
            }

            return store.select(
                getConstructionDiaryLatestUpdatedAtForCommissionId(commissionId)
            ).pipe(
                take(1),
                tap(latestUpdatedAt => {
                    store.dispatch(
                        ConstructionDiaryActionTypes.Load({
                            Payload: {
                                commissionId,
                                updatedSince: latestUpdatedAt
                                    ? moment(latestUpdatedAt).toISOString()
                                    : undefined,
                            },
                        }),
                    );
                }),
                map(() => true),
            );
        })
    );
            }
